import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { _route } from '../../utils';
import TrialExpired from '../../layout/TrailExpired';
import dayjs from 'dayjs';
import { isDevelopment } from '../../utils';

function SubscriptionCheck({ children }) {
  const history = useHistory();
  const { pathname } = useLocation();
  const { store, realm } = useSelector(({ auth }) => auth);
  const { trialEnabled, trialEndsOn } = useSelector(({ auth }) => auth.org);
  const { profile } = store;

  useEffect(() => {
    if (!profile && ['growz', 'aisle'].includes(realm) && !allowedRoutes.includes(pathname)) {
      if (realm.includes('aisle')) {
        history.push(_route(`aisle.intro`));
      } else {
        history.push(_route(`growz.overview`));
      }
    }
  }, [realm]);

  const trialExpired = trialEnabled && dayjs(trialEndsOn).format('YYYYMMDD') < dayjs().format('YYYYMMDD');

  if (trialExpired && !isDevelopment) return <TrialExpired />;

  const allowedRoutes = [
    _route('growz.overview'),
    _route('aisle.intro'),
    _route('account.profile', { realm }),
    _route('account.changePassword', { realm }),
    _route('account.notification', { realm }),
  ];

  if (store.storeId && !allowedRoutes.includes(pathname)) {
    if (store.onboardingDone !== true) {
      history.push(_route('onboarding.store', { storeId: store.storeId }));
      return '';
    }
  }

  return children;
}

export default SubscriptionCheck;
